import { render, staticRenderFns } from "./Protocoles.vue?vue&type=template&id=67eb39f8&scoped=true"
import script from "./Protocoles.vue?vue&type=script&lang=js"
export * from "./Protocoles.vue?vue&type=script&lang=js"
import style0 from "./Protocoles.vue?vue&type=style&index=0&id=67eb39f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb39f8",
  null
  
)

export default component.exports